// Opisy stanów serwisu dla człowieka (docs/pwa/SERWIS.md) - wspólne dla części klienta i serwisanta.
import { CZASY_SERWISU, type CzasSerwisu, type GrantOut } from "../../gen/kontrakt";
import { t } from "../../i18n/t";
import { czas as trwanie, dataGodzina } from "../../uklad/format";
import type { OpcjaFiltra } from "../../uklad/Filtry";
import type { AktywnyDostep, WpisHistorii } from "./Serwis";

/** Czasy dostępu - proponuje serwisant, zgadza się klient (może zmienić). */
export const CZAS: Record<CzasSerwisu, string> = {
  godzina: "Na godzinę",
  dzien: "Na dzień",
  stale: "Do odwołania",
};

export const czasy = (): OpcjaFiltra<CzasSerwisu>[] => CZASY_SERWISU.map((c) => ({ wartosc: c, etykieta: t(CZAS[c]) }));

/** Druga strona dostępu albo sesji ekranu: firma (osoba) albo sama osoba. */
export const kto = (g: { firma?: string; osoba: string }) => (g.firma ? g.firma + " (" + g.osoba + ")" : g.osoba);

/** Otwarte (prośba albo trwający dostęp) - na górze ekranu; reszta to historia. */
export const otwarty = (g: GrantOut) => g.stan === "prosba" || g.stan === "aktywny";

/** Czas trwania dostępu. */
export const doKiedy = (g: GrantOut) => (g.do == null ? t("do odwołania") : t("do {d}", { d: dataGodzina(g.do) }));

/** Sztuki prośby; pusta lista = całe konto (klientowi „Wszystkie Twoje urządzenia”). */
export const urzadzenia = (g: GrantOut, calosc: string) => (g.urzadzenia.length ? g.urzadzenia.join(", ") : calosc);

/** Trwający dostęp: pasek i tekst pozostałego czasu od zgody do końca (#52); do odwołania - bez paska. */
export function dostep(g: GrantOut, nazwa: string, opis: string, teraz: number): AktywnyDostep {
  const d: AktywnyDostep = { id: String(g.id), urzadzenie: nazwa, opis };
  if (g.do != null && g.zgoda != null) {
    const zostalo = Math.max(0, g.do - teraz);
    d.pozostaloProcent = (zostalo / Math.max(1, g.do - g.zgoda)) * 100;
    d.pozostalo = t("Zostało {c} · do {d}", { c: trwanie(zostalo), d: dataGodzina(g.do) });
  } else d.pozostalo = t("Do odwołania");
  return d;
}

/** Wpis historii: co się stało i kiedy. */
export function historia(g: GrantOut): string {
  const kiedy = dataGodzina(g.koniec ?? g.od);
  switch (g.stan) {
    case "wygasla":
      return t("Prośba bez odpowiedzi ({d}).", { d: dataGodzina(g.prosba_do) });
    case "odrzucona":
      return t("Prośba odrzucona ({d}).", { d: dataGodzina(g.od) });
  }
  switch (g.zakonczyl) {
    case "klient":
      return t("Dostęp zakończony przez klienta ({d}).", { d: kiedy });
    case "serwis":
      return t("Dostęp zakończony przez serwis ({d}).", { d: kiedy });
    case "admin":
      return t("Dostęp zakończony przez administratora ({d}).", { d: kiedy });
  }
  return t("Dostęp minął ({d}).", { d: kiedy });
}

/** Wpis karty „Historia” (najnowsze 10). */
export function wpisHistorii(g: GrantOut, nazwa: string): WpisHistorii {
  const status: WpisHistorii["status"] = g.stan === "odrzucona" ? { tekst: t("Odrzucona"), rodzaj: "uwaga" }
    : g.stan === "wygasla" ? { tekst: t("Bez odpowiedzi"), rodzaj: "wylaczona" } : { tekst: t("Zakończony"), rodzaj: "zwykla" };
  return { id: String(g.id), urzadzenie: nazwa, opis: historia(g), status };
}
